/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';

import { MedliSearchView } from '../componentViews/SearchView';

import { useHealthEntryForActiveProfile } from '../../hooks/useHealthEntry';
import { useMedliAnatomyList } from '../../hooks/useMedli';
import { useNavigate } from '../../hooks/useNavigate';

import RouteNames from '../../appAuthorized/RouteNames';
import { eMedliCategoryName } from '../../../constants/MedliNames';

interface GeneralProps {
  match: any;
}
export const HealthEntryAnatomy: React.FC<GeneralProps> = (props) => {
  const healthEntryId = Number(props.match.params.healthEntryId);
  const [{ anatomyList }] = useMedliAnatomyList();
  const [, heActions] = useHealthEntryForActiveProfile(healthEntryId);
  const [, navActions] = useNavigate();

  return (
    <MedliSearchView
      medliCategory={eMedliCategoryName.anatomy}
      medliSearchCategory={eMedliCategoryName.anatomy}
      hasSuggestions={true}
      queryPlaceholder="anatomy.search.field.hint"
      suggestedResults={[{
        results: anatomyList,
      }]}
      onSelectResult={(medliSearchResult) => {
        return new Promise(() => {
          const newHE = heActions.instantiateEditingHealthEntry();
          newHE.anatomy.addMedliSearchTerm(medliSearchResult.searchResult.data);
          heActions.apiUpdate(newHE.data())
            .then(() => {
              navActions.goBackTo(RouteNames.healthEntry(healthEntryId));
            });
        });
      }}
      onGoBack={() => {
        navActions.goBackTo(RouteNames.healthEntry(healthEntryId));
      }}
    />
  );
};
